import '@fancyapps/ui';
import {Fancybox} from "@fancyapps/ui";


window.fbox = Fancybox;


function fboxShowModal(content, params = {}) {


    let defaultParams = {
        trapFocus: false,
        autoFocus: false,
        tpl: {
            closeButton: false,
        },
    };

    params = Object.assign({}, defaultParams, params);

    Fancybox.show(
        [
            {
                html: content,
            },
        ],
        params
    );
}

function fboxShowModalAjax(modalName, url = '/ajax/router.php') {

    const params = new URLSearchParams({action: 'getModal', modal: modalName});

    new Fancybox([
        {
            src: url + '?' + params.toString(),
            type: "ajax",
        },
    ], {
        trapFocus: false,
        autoFocus: false,
        tpl: {
            closeButton: false,
        },
    });
}

window.fboxShowModalAjax = fboxShowModalAjax;
window.fboxShowModal = fboxShowModal;
